import { useGetApiV1LocationCities } from '@/shared/api/generated';

/**
 * Tamanho de página usado na paginação **client-side** da listagem de Cidades.
 *
 * TODO: remover a paginação client-side quando o backend implementar paginação
 * server-side em `GET /api/v1/location/cities`. Hoje o endpoint retorna a lista
 * COMPLETA (sem `page`/`pageSize`/`total`), então fatiamos no front. Quando o
 * backend passar a aceitar esses parâmetros: enviar `page`/`pageSize` para
 * `useCityList`, usar `totalCount`/`totalPages` do envelope e parar de fatiar a
 * lista na página (`src/pages/_authenticated/location/cities`).
 */
export const CITY_PAGE_SIZE = 10;

/**
 * Hook para listar as Cidades cadastradas.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/location/cities`, que retorna
 * a lista completa (sem paginação/busca server-side). Filtragem e ordenação são
 * feitas client-side na camada de UI.
 *
 * @returns Lista de cidades com estado de loading/error e `refetch`.
 */
export function useCityList() {
  const query = useGetApiV1LocationCities();

  return {
    cities: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
